//new vue structure
import Vue from 'vue'
import vueResource from 'vue-resource'
import VeeValidate from 'vee-validate'
import Clipboard from 'v-clipboard'

// import c-swipe files into main.js
// import 'c-swipe/dist/swipe.css';
// import { Swipe, SwipeItem } from 'c-swipe';

//another styles
import VueAwesomeSwiper from 'vue-awesome-swiper'
// require styles
import 'swiper/dist/css/swiper.css'
///



import router from './router'
import store from './store'

Vue.config.productionTip = false
Vue.use(vueResource)
Vue.use(VeeValidate)
Vue.use(Clipboard)
//
// Vue.component('swipe', Swipe);
// Vue.component('swipe-item', SwipeItem);

//2
Vue.use(VueAwesomeSwiper)

/* eslint-disable no-new */
new Vue({
  router,
  store,
  template: `
    <div id="app">
      <router-view></router-view>
    </div>
    `
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js